module.exports = __webpack_public_path__ + "static/media/burgular3.184e6b24.jpg";